import { render, staticRenderFns } from "./CheckoutView.vue?vue&type=template&id=3c756d71&scoped=true&"
import script from "./CheckoutView.vue?vue&type=script&lang=js&"
export * from "./CheckoutView.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutView.vue?vue&type=style&index=0&id=3c756d71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c756d71",
  null
  
)

export default component.exports